// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"4db34432","16":"929762ed","666":"5b230a89","798":"20fcff60"}[chunkId] + ".chunk.js";
};